export default "__VITE_ASSET__0791ace5__"